define('lib/multivariate-testing/save-strategies/user-settings',['require','exports','module','api-access'],function (require, exports, module) {
    var apiAccess = require('api-access');

    /**
     * Saves a variation ID for the specified test via the user settings API.
     *
     * @param {string} testId
     * @param {string} variationId
     * @returns {Promise}
     */
    module.exports = function (testId, variationId) {
        var userSettings = {};
        userSettings[testId] = variationId;

        return apiAccess.user.updateSettings(userSettings);
    };
});

